class ShippingReturnsTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.panels = this.tabs.map((tab) => this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`));
    this.onClick = this.onClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.addEventListener('click', this.onClick);
    this.addEventListener('keydown', this.onKeyDown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('keydown', this.onKeyDown);
  }

  selectTab(index, focus = false) {
    this.tabs.forEach((tab, tabIndex) => {
      const selected = tabIndex === index;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
      this.panels[tabIndex].hidden = !selected;
    });

    if (focus) this.tabs[index].focus();
  }

  onClick(event) {
    const tab = event.target.closest('[role="tab"]');
    const index = this.tabs.indexOf(tab);
    if (index !== -1) this.selectTab(index);
  }

  onKeyDown(event) {
    const index = this.tabs.indexOf(event.target);
    if (index === -1) return;

    const nextIndex = {
      ArrowRight: (index + 1) % this.tabs.length,
      ArrowLeft: (index - 1 + this.tabs.length) % this.tabs.length,
      Home: 0,
      End: this.tabs.length - 1,
    }[event.key];

    if (nextIndex === undefined) return;
    event.preventDefault();
    this.selectTab(nextIndex, true);
  }
}

if (!customElements.get('shipping-returns-tabs')) {
  customElements.define('shipping-returns-tabs', ShippingReturnsTabs);
}
